import { apiClient, makeServicePlugin, BaseModel } from "@/store/api";

class Pdfs extends BaseModel {
    constructor(data, options) {
        super(data, options);
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = "Pdfs";

    // Define default properties here
    static instanceDefaults() {
        return {
            context: ""
        };
    }
}
const servicePath = "pdfs";
const servicePlugin = makeServicePlugin({
    Model: Pdfs,
    service: apiClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
apiClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin;
